module.exports = __webpack_public_path__ + "img/parea.94fbe840.svg";